import { SmartTagButtonFacet } from '@process-creative/slate-ajax-collection';
import { handlize } from '@process-creative/slate-theme-tools';

export class CustomSmartTagButtonFacet extends SmartTagButtonFacet {

  getPrint() {
    const options = this.getOptionsToDraw();

    return options.reduce((x, option) => {
      const optionHandle = this.template.escape(option);
      const optionName = this.getOptionName(option);
      const isSelected = this.isSelected(optionHandle);
      return x += `
        <li class="o-select-box__option">
          <button
            class="c-faceted-nav__facet-btn o-select-box__option-btn o-type--2--caps
            ${isSelected ? 'is-selected' : ''}"
            data-button-facet data-option="${optionHandle}"
          >${optionName}
          </button>
        </li>
      `;
    }, '');
  }

  getTemplate(title, body) {
    return `
        ${body}
    `;
  }
}